export const API_URL_FETCH_PICKUP_POINTS_FOR_ZIP_CODE = (zipCode: string) =>
    `/shop/api/pickuppointsforzipcode/${zipCode}`;
